import { render, staticRenderFns } from "./SinglePieChart.vue?vue&type=template&id=64f11e8c&scoped=true"
import script from "./SinglePieChart.vue?vue&type=script&lang=js"
export * from "./SinglePieChart.vue?vue&type=script&lang=js"
import style0 from "./SinglePieChart.vue?vue&type=style&index=0&id=64f11e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f11e8c",
  null
  
)

export default component.exports